import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'
import _ from 'lodash'

export default function useGetTransactionRepeatOptions({
  date = undefined,
  recurring_setting_id = undefined,
  enabled,
}: {
  recurring_setting_id?: number
  date?: string
  enabled: boolean
}) {
  const fetchData = async () => {
    const response = await httpClient.post(
      `/team/cash-flow/transactions/recurring-settings`,
      {
        recurring_setting_id: recurring_setting_id ?? undefined,
        transaction_date: date,
      },
    )

    const optionsArray = Object.entries(response.data.data.options).map(
      ([name, props]) => {
        const otherProps = { ...props }

        if (
          otherProps?.settings?.week_days &&
          otherProps?.settings?.week_days?.length
        ) {
          otherProps.settings.week_days = otherProps.settings.week_days.map(
            (x) => _.startCase(_.toLower(x)),
          )
        }

        return {
          name,
          ...otherProps,
        }
      },
    )
    return optionsArray
  }

  // const key = `transaction-categories`

  return useQuery({
    queryKey: ['transaction-repeat-options', { date, recurring_setting_id }],
    queryFn: fetchData,
    enabled: enabled,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
